import React from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import s from './CityLinks.css';

// "Popular services in top cities" SEO link grid. Self-contained replica of the home page's
// SEO_SERVICES × TOP_CITIES list (the home keeps those constants module-private), so this stays
// additive. Each link feeds the service×city SEO pages (/services/:service/:cityState).
const TOP_CITIES = [
  ['New York', 'new-york-ny'], ['Los Angeles', 'los-angeles-ca'], ['Chicago', 'chicago-il'],
  ['Houston', 'houston-tx'], ['Phoenix', 'phoenix-az'], ['Dallas', 'dallas-tx'],
];
const SEO_SERVICES = [
  ['Cleaning', 'cleaning'], ['Plumbing', 'plumbing'], ['TV Mounting', 'tv-mounting'],
  ['Moving Help', 'moving-help'], ['Junk Removal', 'junk-removal'],
];

function CityLinks({ heading = 'Popular services in top cities' }) {
  return (
    <div className={s.block}>
      <h2 className={s.heading}>{heading}</h2>
      <div className={s.grid}>
        {SEO_SERVICES.map(([name, sl]) => (
          <div key={sl} className={s.col}>
            <div className={s.svc}>{name}</div>
            {TOP_CITIES.map(([cn, cs]) => (
              <a key={cs} href={`/services/${sl}/${cs}`} className={s.link}>
                {name} in {cn}
              </a>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}

export default withStyles(s)(CityLinks);
